<div class="widget-iframe">
  <div class="iframe-cont" [class.chat]="topLocationIsChat">
    <div class="iframe-main">
      <div class="iframe-main-conto reader" *ngIf="routing.isReader()">
        <app-news-view
          *ngIf="article"
          [apicall]="{ apicall: article, match: match, tag: tag }"
        ></app-news-view>
      </div>
      <div
        class="iframe-main-conto reader story"
        *ngIf="routing.isStoryReader()"
      >
        <app-news-feed
          style="width: 100%"
          *ngIf="newsfeedStory"
          [newsfeedData]="newsfeedStory"
        ></app-news-feed>
      </div>
    </div>
  </div>
</div>
